/**
 * Meldet unbehandelte Browser-Fehler anonym an /api/client-errors (max. 8 pro Sitzung, ohne Duplikate).
 */
const seen = new Set<string>();

function report(message: string, source = '', stack = '') {
  try {
    if (!message || seen.size >= 8) return;
    const key = message + source;
    if (seen.has(key)) return;
    seen.add(key);
    fetch('/api/client-errors', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
      body: JSON.stringify({ message, source, stack, url: location.href }),
    }).catch(() => {});
  } catch { /* nie selbst Fehler werfen */ }
}

window.addEventListener('error', (e) => {
  if (!e.message || /ResizeObserver|Script error/i.test(e.message)) return;
  report(e.message, `${e.filename || ''}:${e.lineno || 0}`, (e.error && e.error.stack) || '');
});
window.addEventListener('unhandledrejection', (e) => {
  const r: any = e.reason;
  const msg = String(r?.message ?? r ?? '');
  if (!msg || /Failed to fetch dynamically imported|Importing a module script failed|Load failed|NetworkError|AbortError|cancel/i.test(msg)) return;
  report(`Unhandled rejection: ${msg}`, '', r?.stack || '');
});
